import { Music } from 'lucide-react';

const PHRASES = [
  'CONECTAMOS O SUL ATRAVÉS DA MÚSICA',
  'AQUI É BAILÃO',
];

const TickerContent = () => (
  <span className="inline-flex items-center">
    {Array.from({ length: 4 }).map((_, i) => (
      <span key={i} className="inline-flex items-center">
        {PHRASES.map((phrase, j) => (
          <span key={j} className="inline-flex items-center">
            <span className="marquee-text mx-3">{phrase}</span>
            <Music className="w-4 h-4 text-[hsl(30,100%,50%)] mx-2 flex-shrink-0" />
          </span>
        ))}
      </span>
    ))}
  </span>
);

const MarqueeTicker = () => {

  return (
    <div className="w-full overflow-hidden bg-gradient-to-r from-black via-[hsl(0,0%,6%)] to-black border-y border-[hsl(30,100%,50%,0.15)] py-2.5 relative">
      <div className="absolute inset-0 marquee-sheen pointer-events-none z-10" />
      <div className="marquee-track whitespace-nowrap inline-flex">
        <TickerContent />
        <TickerContent />
      </div>
    </div>
  );
};

export default MarqueeTicker;
